import { schema } from 'normalizr';

export const impactAssessmentSchema = new schema.Entity('impactAssessments', {}, { idAttribute: 'ImpactAssessmentId' });
export const impactAssessmentListSchema = [impactAssessmentSchema];
